module CheckboxRange {
	export function construct() {
		$("tbody tr input[type=checkbox]").click(handleCheckboxChecked);
	}

	function handleCheckboxChecked(event: JQuery.Event<HTMLElement, null>) {
		const clickedCheckbox = $(this);
		const selectedCells = TableRangeSelection.getSelectedCells(clickedCheckbox);
		if (selectedCells == null) {
			return;
		}
		const newValue = clickedCheckbox.is(":checked");

		selectedCells.forEach(function (td) {
			const checkbox = td.find("input[type=checkbox]");
			if (checkbox.is(':disabled')) {
				return;
			}
			checkbox.prop("checked", newValue);
		});
	}
}

$(document).ready(() => {
	CheckboxRange.construct();
});